<template>
  <div>
    <facebook-post-preview
      v-if="activityType === types.FacebookPagePosts || activityType === types.FacebookPersonalPosts"
      :pieces="pieces"
      :default-view="defaultView"
      :date="date"
      :profile="profile"
    />
    <linked-in-post-preview
      v-if="activityType === types.LinkedInPersonalPosts"
      :pieces="pieces"
      :default-view="defaultView"
      :date="date"
      :profile="profile"
    />
    <twitter-post-preview
      v-if="activityType === types.TwitterPersonalPosts"
      :pieces="pieces"
      :default-view="defaultView"
      :date="date"
      :profile="profile"
    />
  </div>
</template>

<script>
import FacebookPostPreview from './facebook/FacebookPostPreview';
import LinkedInPostPreview from './linkedIn/LinkedInPostPreview.vue';
import TwitterPostPreview from './twitter/TwitterPostPreview.vue';
import {SocialPostTypes} from '../SocialPostTypes';

export default {
  components: {
    FacebookPostPreview,
    LinkedInPostPreview,
    TwitterPostPreview,
  },
  props: {
    activityType: {
      type: String,
      required: true,
    },
    pieces: {
      type: Array,
      required: true,
    },
    date: Number,
    profile: {
      type: Object,
    },
    defaultView: {
      type: Boolean,
      required: true,
    },
    image: {
      type: String,
    },
  },
  computed: {
    types() {
      return SocialPostTypes;
    },
  },
};
</script>
